import { RouteInput } from "../pages/route-planner/RouteMenu";
import { Species } from "../types";

const BASE_URL = "https://pallas-api.onrender.com/api";
const VERSION = "v1";
const API_URL = `${BASE_URL}/${VERSION}`

export const FISHING_SPOTS_URL = `${API_URL}/spots`;
export const FISHING_HEATMAP_URL = `${API_URL}/heatmap`;
export const FISH_FACILITIES_URL = `${API_URL}/fishfacilities`;
export const ROUTE_URL = `${API_URL}/route`;
export const AIS_URL = `${API_URL}/ais`;

type PallasService = {
  getSpots: (species: string) => Promise<FishingSpotsRootObject>
  getHeatmap: (daysAhead: number, species?: string) => Promise<FishingSpotsRootObject>
  getFacilites: () => Promise<FacilitiesRootObject>
  getRoute: (routeInput: RouteInput) => Promise<any>
}

const pallas: PallasService = {
  getSpots: (species, daysAhead = 7) => fetch(`${FISHING_SPOTS_URL}?species=${species}&daysAhead=${daysAhead}`).then(res => res.json()),
  getHeatmap: (daysAhead, species) => fetch(`${FISHING_HEATMAP_URL}?species=${species ?? Species(s => s)[0].value}&daysAhead=${daysAhead}`).then(res => res.json()),
  getFacilites: () => fetch(FISH_FACILITIES_URL).then(res => res.json()),
  getRoute: (routeInput: RouteInput) => {
    return fetch(ROUTE_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(routeInput)
    }).then(res => res.json())
  }
};

export default pallas;

export interface SpotProperties {
  Bruttovekt: number;
  Prob: number;
  Shape_Area?: any;
  Shape_Length?: any;
  globalid: string;
  havomr: string;
  lokasjon: string;
  lokref: string;
  objectid: number;
  [key: string]: any;
}

export interface FacilityProperties {
  address: string
  city: string
  contact: string
  dist: number
  email: string
  id: string
  kjNumber: string
  lat: number
  lng: number
  mobile: string
  name: string
  orgNumber: string
  phone: string
  type: string
}

export interface Geometry {
  type: string;
  coordinates: number[][][];
}

export interface Feature<P> {
  id: string;
  type: string;
  properties: P;
  geometry: Geometry;
}

export interface FishingSpotsRootObject {
  type: string;
  features: Feature<SpotProperties>[];
}

export interface FacilitiesRootObject {
  type: string;
  features: Feature<FacilityProperties>[];
}
